export const noop = (...any: any): void => void 0;

export function createTimeoutSignal(timeoutMs: number): AbortSignal {
  if (typeof AbortSignal.timeout === 'function') {
    return AbortSignal.timeout(timeoutMs);
  }
  const controller = new AbortController();
  const timerId = setTimeout(() => controller.abort(new DOMException('Timeout', 'TimeoutError')), timeoutMs);
  controller.signal.addEventListener('abort', () => clearTimeout(timerId), { once: true });
  return controller.signal;
}
